import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ElementoCarro } from '../../../model/interface/ElementoCarro';
import * as _ from 'lodash';
import { IProducto } from '../../../model/interface/IProducto';
import {ICodigoProducto} from '../../../model/interface/ICodigoProducto';

@Injectable()
export class CarritoService {


  private productos: ElementoCarro[] = [];
  private listadoPorductos = new BehaviorSubject<ElementoCarro[]>(this.productos);
  carroProductos = this.listadoPorductos.asObservable();



  constructor() {
    if (localStorage.getItem('carrito')) {
      this.productos = JSON.parse(localStorage.getItem('carrito'));
    }

    this.listadoPorductos.next(this.productos);
  }

  establecerCantidad (cotizacion: ElementoCarro, cantidad: number): void {

    /**
     * Busco si el producto existe, si existe le sumo 1, si no lo agrego
     */

    if (isNaN(Number(cantidad)) || cantidad == null || typeof cantidad === 'undefined') {
      cantidad = 1;
    } else if (cantidad < 0) {
      cantidad = 0;
    } else if (cantidad > 100) {
      cantidad = 100;
    }

    const encontrado: ElementoCarro = _.find(this.productos, (carro) => {

      if (cotizacion.codigo) {
        if (carro.codigo) {
          return (carro.producto.id === cotizacion.producto.id &&  carro.codigo.id === cotizacion.codigo.id );
        }
      } else {
        return (carro.producto.id === cotizacion.producto.id &&  !carro.codigo);
      }
    });

    if (encontrado) {
      encontrado.cantidad = cantidad;
    } else {
      cotizacion.cantidad = cantidad;
      this.productos.push(cotizacion);
    }

    this.toLocalStorage();
    this.listadoPorductos.next(this.productos);
  }

  /**
   *
   * @param cotizacion
   * @param indice indica la posision en la que se agregara el elemento
   */

  agregarProducto (cotizacion: ElementoCarro, indice?: number): void {

    /**
     * Busco si el producto existe, si existe le sumo 1, si no lo agrego
     */

    const encontrado: ElementoCarro = _.find(this.productos, (carro) => {

      if (cotizacion.codigo) {
        if (carro.codigo) {
          return (carro.producto.id === cotizacion.producto.id &&  carro.codigo.id === cotizacion.codigo.id );
        }
      } else {
        return (carro.producto.id === cotizacion.producto.id &&  !carro.codigo);
      }
    });

    if (encontrado) {
      encontrado.cantidad++;
    } else {
      cotizacion.cantidad++;

      if (indice) {
        this.productos.splice((indice + 1), 0, cotizacion);
      } else {
        this.productos.push(cotizacion);
      }

    }

    this.toLocalStorage();
    this.listadoPorductos.next(this.productos);
  }

  quitarProducto (cotizacion: ElementoCarro): void {

    /**
     * Busco si el producto existe, si existe le resto 1
     */

    const encontrado: ElementoCarro = _.find(this.productos, (carro) => {
      if (cotizacion.codigo) {
        if (carro.codigo) {
          return (carro.producto.id === cotizacion.producto.id &&  carro.codigo.id === cotizacion.codigo.id );
        }
      } else {
        return (carro.producto.id === cotizacion.producto.id &&  !carro.codigo);
      }
    });

    if (encontrado) {

      /**
       * Se hace fuera del if para que se actualize en el controlador
       */
      encontrado.cantidad--;

      if (encontrado.cantidad === 0) {
        _.remove(this.productos, (carro) => {
          if (cotizacion.codigo) {
            if (carro.codigo) {
              return (carro.producto.id === cotizacion.producto.id &&  carro.codigo.id === cotizacion.codigo.id );
            }
          } else {
            return (carro.producto.id === cotizacion.producto.id &&  !carro.codigo);
          }
        });
      }
    }

    this.toLocalStorage();
    this.listadoPorductos.next(this.productos);
  }

  eliminarProducto (cotizacion: ElementoCarro): void {

    /**
     * Busco si el producto existe, si existe le resto 1
     */
    _.remove(this.productos, (carro) => {
      if (cotizacion.codigo) {
        if (carro.codigo) {
          return (carro.producto.id === cotizacion.producto.id &&  carro.codigo.id === cotizacion.codigo.id );
        }
      } else {
        return (carro.producto.id === cotizacion.producto.id &&  !carro.codigo);
      }
    });

    this.toLocalStorage();
    this.listadoPorductos.next(this.productos);
  }

  toLocalStorage(): void {

    const auxProductos: ElementoCarro[] = [];

    _.each(this.productos, function (item) {

      const itemAux: any = {producto: {} };

      itemAux.cantidad = item.cantidad;
      itemAux.codigo = item.codigo;
      itemAux.producto.id = item.producto.id;
      itemAux.producto.nombre = item.producto.nombre;
      itemAux.producto.imagen = item.producto.imagen;
      itemAux.producto.codigos = item.producto.codigos;

      auxProductos.push(itemAux);
    });


    localStorage.setItem('carrito', JSON.stringify(auxProductos));
  }

  enriquecerProductos(listProductos: IProducto[]): ElementoCarro[] {

    let listCarro: ElementoCarro[];

    console.log('this.productos', this.productos);

    listCarro = _.map(listProductos, (prod: any) => {

      let cantidad = 0;
      const encontrado: ElementoCarro = _.find(this.productos, (item) => {
        if (item.codigo) {
          return (item.producto.id === prod.id && item.codigo.id === prod.codigos[0].id);
        } else {
          return false;
        }
      });
      console.log('encontrado', encontrado);
      if (encontrado) {
        cantidad = encontrado.cantidad;
      }
      return { cantidad: cantidad, producto:  prod, codigo: (prod.codigos ? prod.codigos[0] : undefined) };
    });

    return listCarro;
  }

  /**
   * Para listado de codigos en detalle de producto
   *
   * @param listCodigos
   * @param producto
   * @returns {ElementoCarro[]}
   */

  enriquecerCodigos(listCodigos: ICodigoProducto[], producto: IProducto): ElementoCarro[] {

    let listCarro: ElementoCarro[];

    listCarro = _.map(listCodigos, (codigo: any) => {

      let cantidad = 0;
      const encontrado: ElementoCarro = _.find(this.productos, (item) => {
        if (item.codigo) {
          return item.codigo.id === codigo.id;
        }
      });
      if (encontrado) {
        cantidad = encontrado.cantidad;
      }
      return { cantidad: cantidad, producto:  producto, codigo: codigo};
    });

    return listCarro;
  }

  actualizarProductos(inCarro: ElementoCarro[]): ElementoCarro[] {

    let listCarro: ElementoCarro[];

    listCarro = _.map(inCarro, (elemento: ElementoCarro) => {

      let cantidad = 0;
      const encontrado: ElementoCarro = _.find(this.productos, (item) => {
        if (elemento.codigo) {
          if (item.codigo) {
            return (item.producto.id === elemento.producto.id &&  item.codigo.id === elemento.codigo.id );
          }
        } else {
          return (item.producto.id === elemento.producto.id &&  !item.codigo);
        }
      });
      if (encontrado) {
        cantidad = encontrado.cantidad;
      }

      elemento.cantidad = cantidad;

      return elemento;
    });

    return listCarro;
  }


  vaciarCarro() {

    this.productos = [];

    this.toLocalStorage();
    this.listadoPorductos.next(this.productos);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/carrito/carrito.service.ts